/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
/**
 * EventService订阅枚举
 */
export enum EventServiceKeyE {
    /**
     * 左菜单展开/收缩（core库也在用该事件名，需同步修改）
     */
    MenuExpandChange = 'MenuExpandChange',
    /**
     * 极简模式左菜单展开/收缩（core库也在用该事件名，需同步修改）
     */
    SimpleMenuExpandChange = 'simpleMenuExpandChange',
    /**
     * 主题切换事件
     */
    ThemeChanged = 'themeChanged',
    /**
     * 极简/标准模式切换Tip
     */
    SimpleModeTipHide = 'simpleModeTipHide',
    /**
     * 创建/删除了NFS共享
     */
    NfsChanged = 'nfsChanged',
    /**
     * 创建/删除了CIFS共享
     */
    CifsChanged = 'cifsChanged',
    /**
     * 点击了助手里“会弹出侧滑框”的按钮
     */
    ClickAssistantCreateBtn = 'clickAssistantCreateBtn',
    /**
     * 登录用户信息改变
     */
    USER_INFO_CHANGED = 'userInfoChanged',
    /**
     * 容量趋势接口数据更新
     */
    FORECASTING_DATA_CHANGE = 'forecastingDataChange',
    /**
     * 任务中心页面加载
     */
    TASK_PAGE_LOAD = 'taskPageLoad',
}
